import {
  mdiPhone,
  mdiEmail,
  mdiChat,
  mdiMessageVideo,
  mdiWhatsapp,
  mdiPhoneInTalkOutline,
  mdiSkype,
  mdiMessageProcessing,
  mdiAccountGroup,
  mdiChatProcessing
} from "@mdi/js";

export default {
  mdiPhone,
  mdiEmail,
  mdiChat,
  mdiMessageVideo,
  mdiWhatsapp,
  mdiPhoneInTalkOutline,
  mdiSkype,
  mdiMessageProcessing,
  mdiAccountGroup,
  mdiChatProcessing
};
